
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31.3 31.3"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11.9","cy":"11.9","r":"9.1","opacity":".64","fill":"none","stroke":"#fff","stroke-width":"5.6","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"25.9","cy":"25.9","r":"4.9","opacity":".64","fill":"#fff","stroke":"#fff","stroke-miterlimit":"10"}})])
          )
        }
      }
    